module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/send-icon.dd51d806.svg";